/**
 * The function `initToggleMenuMobile` toggles the visibility of a mobile menu when a specific element
 * is clicked.
 */
var initToggleMenuMobile = function initToggleMenuMobile() {
  var menuToggle = document.querySelector("#menu-mobile-toggle-js");
  var menuMobile = document.querySelector("#menu-mobile-js");
  if (!menuToggle) {
    return;
  }
  menuToggle.addEventListener("click", function () {
    menuToggle.classList.toggle("opened");
    menuMobile.classList.toggle("opened");
  });
};
export { initToggleMenuMobile };